var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var PlaceholderBtn = /** @class */ (function (_super) {
    __extends(PlaceholderBtn, _super);
    function PlaceholderBtn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlaceholderBtn.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons" },
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-text" }),
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-odd" })),
            React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons" },
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-text" }),
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-odd" })),
            React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons" },
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-text" }),
                React.createElement("div", { className: "rj-ev-list__placeholder__card-buttons-odd" })),
            React.createElement("div", { className: "rj-ev-list__placeholder__empty-element" })));
    };
    return PlaceholderBtn;
}(React.PureComponent));
export { PlaceholderBtn };
//# sourceMappingURL=PlaceholderBtn.js.map